import { render, staticRenderFns } from "./BuildingsHistoryList.vue?vue&type=template&id=7175d89c&scoped=true"
import script from "./BuildingsHistoryList.vue?vue&type=script&lang=js"
export * from "./BuildingsHistoryList.vue?vue&type=script&lang=js"
import style0 from "./BuildingsHistoryList.vue?vue&type=style&index=0&id=7175d89c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7175d89c",
  null
  
)

export default component.exports